import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getCandidate, updateCandidate } from "../api/recruitmentApi";
import { formatDate, normalizeItem, statusClass } from "./hrUtils";
import "./HRShared.css";
import "./CandidateDetail.css";

const CandidateDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [candidate, setCandidate] = useState(null);
  const [stage, setStage] = useState("");
  const [error, setError] = useState("");

  const loadCandidate = async () => {
    try {
      const response = await getCandidate(id);
      const data = normalizeItem(response);
      setCandidate(data);
      setStage(data.stage || "Applied");
    } catch (requestError) {
      setError(requestError.message);
    }
  };

  useEffect(() => { loadCandidate(); }, [id]);

  const saveStage = async () => {
    try {
      await updateCandidate(id, { stage });
      await loadCandidate();
    } catch (requestError) {
      setError(requestError.message);
    }
  };

  if (!candidate) {
    return <div className="hr-page">{error ? <div className="hr-error">{error}</div> : <div className="hr-card hr-loading">Loading candidate...</div>}</div>;
  }

  return (
    <div className="hr-page">
      <header className="hr-page-header">
        <div>
          <button className="hr-detail-back" onClick={() => navigate(-1)}>← Back</button>
          <h1>{candidate.candidateName}</h1>
          <p>{candidate.jobOpening?.jobTitle || "Candidate profile"}</p>
        </div>
        <span className={`hr-status ${statusClass(candidate.stage)}`}>{candidate.stage}</span>
      </header>

      {error && <div className="hr-error">{error}</div>}

      <section className="hr-two-column">
        <article className="hr-card hr-panel">
          <h2 className="hr-panel-title">Candidate Information</h2>
          <div className="hr-detail-grid">
            {[
              ["Email", candidate.email],
              ["Phone", candidate.phone],
              ["Current company", candidate.currentCompany],
              ["Experience", candidate.experience ? `${candidate.experience} years` : "-"],
              ["Expected salary", candidate.expectedSalary ? `₹${Number(candidate.expectedSalary).toLocaleString("en-IN")}` : "-"],
              ["Notice period", candidate.noticePeriod],
              ["Source", candidate.source],
              ["Added on", formatDate(candidate.createdAt)],
            ].map(([label,value]) => <div className="hr-detail-item" key={label}><small>{label}</small><strong>{value || "-"}</strong></div>)}
          </div>
        </article>

        <article className="hr-card hr-panel">
          <h2 className="hr-panel-title">Update Hiring Stage</h2>
          <select className="hr-select" value={stage} onChange={(e) => setStage(e.target.value)}>
            {["Applied","Screening","Shortlisted","Interview Scheduled","Interview Completed","Selected","Offer Sent","Offer Accepted","Joined","Rejected","On Hold"].map((value) => <option key={value}>{value}</option>)}
          </select>
          <button className="hr-btn hr-btn-primary hr-detail-save" onClick={saveStage}>Save Stage</button>
        </article>
      </section>

      <section className="hr-card hr-panel">
        <h2 className="hr-panel-title">Recruitment Activity</h2>
        <div className="hr-timeline">
          {(candidate.activities || []).length ? candidate.activities.map((activity,index) => (
            <div className="hr-timeline-item" key={activity._id || index}>
              <div className="hr-timeline-dot"/>
              <div><strong>{activity.title || activity.type}</strong><p>{activity.description || ""}</p><small>{formatDate(activity.createdAt)}</small></div>
            </div>
          )) : <div className="hr-empty">No activity recorded yet.</div>}
        </div>
      </section>
    </div>
  );
};

export default CandidateDetail;
